package org.hs_soft.runmynesto.pages.home.sub_page.media_center.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.media_detail.GetMedia
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.grid_function.FilterActiveGridContent
import org.hs_soft.runmynesto.pages.components.grid_function.GridFunction
import org.hs_soft.runmynesto.pages.components.grid_function.GridItemsList
import org.hs_soft.runmynesto.pages.components.FilterRow

@Composable
fun GridMediaCenterBar(
    windowSizeMode: WindowSizeModeEnum,
    selectedItem: GetMedia?,
    searchValue: String,
    infoList: List<dynamic>,
    titleDescending: Boolean,
    numberDescending: Boolean,
    showNumberSortIcon: Boolean,
    showTitleSortIcon: Boolean,
    showFilterComponent: Boolean,
    selectedFilterOption: GridItemsFilterEnum,
    onSearchValueChange: (String) -> Unit,
    onGridItemClick: (String)->Unit,
    onAddRecord: () -> Unit,
    onTitleSortClick: () -> Unit,
    onNumberSortClick: () -> Unit,
    refreshList: () -> Unit,
    onSwipeRight: () -> Unit,
    onFilterComponentClick: () -> Unit,
    onCloseFilterClick: () -> Unit,
    selectFilterType: (GridItemsFilterEnum) -> Unit,
    submitFilterItems: () -> Unit
) {
    var startX by remember { mutableStateOf(0.0) }
    var endX by remember { mutableStateOf(0.0) }
    var tracking by remember { mutableStateOf(false) }
    Column(
        modifier = Modifier
            .fillMaxHeight()
            .thenIf(
                windowSizeMode==WindowSizeModeEnum.PHONE,
                Modifier.fillMaxWidth()
            )
    )
    {
        FilterRow(
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            width = Dimen.gridWidth,
            selectedFilterType = selectedFilterOption,
            onAddRecordClick = {
                onAddRecord()
            },
            onFilterClick = {
                onFilterComponentClick()
            },
        )

        Box(
            modifier = Modifier
                .weight(1f)
                .thenIf(
                    windowSizeMode==WindowSizeModeEnum.PHONE,
                    Modifier.fillMaxWidth()
                )
                .margin(
                    top = Dimen.smallPadding,
                )
        )
        {
            if (showFilterComponent) {
                FilterActiveGridContent(
                    selectFilterType = {
                        selectFilterType(it)
                    },
                    selectedFilterType = selectedFilterOption,
                    onCloseFilterClick = {
                        onCloseFilterClick()
                    },
                    submitFilterItems = {
                        submitFilterItems()
                    }

                )
            }

            Column(
                modifier = Modifier
                    .fillMaxHeight()
                    .thenIf(
                        windowSizeMode==WindowSizeModeEnum.PHONE,
                        Modifier.fillMaxWidth()
                    )
            ) {
                CustomEditText(
                    width =Dimen.gridWidth,
                    fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                    label = "",
                    value = searchValue,
                    endIconPath = Res.PathIcon.searchBox,
                    isRequired = false,
                    marginTop = Dimen.smallPadding,
                    hint = Strings.current().search,
                    onFocusIn = {},
                    onFocusOut = {},
                    onInputChange = {it, validation ->
                        onSearchValueChange(it)
                    },
                )

                GridFunction(
                    modifier = Modifier,
                    fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                    title = Strings.current().name,
                    infoTitle = Strings.current().numberDot,
                    footerTitle = Strings.current().items,
                    infoList = infoList,
                    onTitleSortClick = {
                        onTitleSortClick()
                    },
                    onNumberSortClick = {
                        onNumberSortClick()
                    },
                    refreshList = { refreshList() },
                    content = {
                        GridItemsList(
                            id = selectedItem?.id ?: "",
                            items = infoList,
                            onItemClick = {
                                onGridItemClick(it)
                            },
                        )
                    },
                    titleDescending = titleDescending,
                    numberDescending = numberDescending,
                    showTitleSortIcon = showTitleSortIcon,
                    showNumberSortIcon = showNumberSortIcon,

                )
            }
        }


    }

}